var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_11188)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51126 5.26126C6.03871 4.73382 6.75408 4.4375 7.5 4.4375H10.5C10.5081 4.4375 10.5162 4.43767 10.5243 4.43802C11.0851 4.46224 11.6259 4.65375 12.077 4.9879C12.5281 5.32205 12.8689 5.78356 13.0555 6.31302C13.1588 6.60602 13.005 6.92725 12.712 7.03051C12.419 7.13378 12.0977 6.97997 11.9945 6.68698C11.8825 6.3693 11.6781 6.09239 11.4074 5.8919C11.1397 5.69365 10.8195 5.57908 10.487 5.5625H7.5C7.05245 5.5625 6.62323 5.74029 6.30676 6.05676C5.99029 6.37323 5.8125 6.80245 5.8125 7.25C5.8125 7.69755 5.99029 8.12678 6.30676 8.44324C6.62322 8.75971 7.05245 8.9375 7.5 8.9375H10.5C11.2459 8.9375 11.9613 9.23382 12.4887 9.76126C13.0162 10.2887 13.3125 11.0041 13.3125 11.75C13.3125 12.4959 13.0162 13.2113 12.4887 13.7387C11.9613 14.2662 11.2459 14.5625 10.5 14.5625H7.5C7.49191 14.5625 7.48382 14.5623 7.47574 14.562C6.91487 14.5378 6.37409 14.3463 5.92298 14.0121C5.47188 13.6779 5.13109 13.2164 4.94449 12.687C4.84122 12.394 4.99503 12.0727 5.28802 11.9695C5.58102 11.8662 5.90225 12.02 6.00552 12.313C6.11748 12.6307 6.32195 12.9076 6.59261 13.1081C6.86026 13.3064 7.18052 13.4209 7.51301 13.4375H10.5C10.9476 13.4375 11.3768 13.2597 11.6932 12.9432C12.0097 12.6268 12.1875 12.1976 12.1875 11.75C12.1875 11.3024 12.0097 10.8732 11.6932 10.5568C11.3768 10.2403 10.9476 10.0625 10.5 10.0625H7.5C6.75408 10.0625 6.03871 9.76618 5.51126 9.23874C4.98382 8.71129 4.6875 7.99592 4.6875 7.25C4.6875 6.50408 4.98382 5.78871 5.51126 5.26126Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.1875C9.31066 2.1875 9.5625 2.43934 9.5625 2.75V5C9.5625 5.31066 9.31066 5.5625 9 5.5625C8.68934 5.5625 8.4375 5.31066 8.4375 5V2.75C8.4375 2.43934 8.68934 2.1875 9 2.1875ZM9 13.4375C9.31066 13.4375 9.5625 13.6893 9.5625 14V16.25C9.5625 16.5607 9.31066 16.8125 9 16.8125C8.68934 16.8125 8.4375 16.5607 8.4375 16.25V14C8.4375 13.6893 8.68934 13.4375 9 13.4375Z",
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_11188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.1b7a35ad05e600739cae3ceb7cdedecb.svg";
export { ForwardRef as ReactComponent };